module.exports = "/assets/data/8faa61b032e5525a0eca710979a0b6cb-BT6.data.json";